













import { ColorEnum } from '../../../enums';

import { OriginsStepEnum } from './origins.component';

export default {
  name: 'origins-step',
  props: {
    step: {
      type: Number,
      required: true
    },
    messages: {
      type: Object,
      required: true
    }
  },
  computed: {
    color: function (): ColorEnum {
      return {
        [OriginsStepEnum.DEFAULT]: () => ColorEnum.LIGHT_GREY,
        [OriginsStepEnum.PREDICTIVE]: () => ColorEnum.BLUE,
        [OriginsStepEnum.REFINEMENT]: () => ColorEnum.YELLOW
      }[this.step]();
    }
  }
};

